import { render, staticRenderFns } from "./ManagePayroll.vue?vue&type=template&id=5f888acc&scoped=true"
import script from "./ManagePayroll.vue?vue&type=script&lang=ts"
export * from "./ManagePayroll.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f888acc",
  null
  
)

export default component.exports